import React from "react";
import { Dropdown } from "react-bootstrap";

export default function DownloadComponent({ options, onDownload, btnName = "Download", type }) {
  return (
    <div className="dropCustom">
      <Dropdown>
        <Dropdown.Toggle
          variant="success"
          className="border bd_master h_32x d-flex align-items-center justify-content-center cursor-pointer bg-white br_6"
          id="dropdown-basic"
        >
          {/* <i className="fas fa-download text_master"></i> */}
          <label className="mb-0 collection_details mt-0 cursor-pointer text-start text_master font_16 font_500">{btnName}</label>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {options.map((option, index) => (
            <Dropdown.Item
              key={index}
              onClick={() => onDownload(option.type, type)}
              href="#"
            >
              <div className="d-flex align-items-center">
                <i className={`${option.icon} text-${option.iconColor} font_20`}></i>{" "}
                <h6 className="font_14 mb-0 ms-2">{option.label}</h6>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
